import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '#environments';
import {
    CreateSnapshotBatchResponse,
    PaginatedResult,
    SnapshotBatchItem,
    SnapshotBatchJobStatus,
    SnapshotRunSummary,
} from '#models';

@Injectable({ providedIn: 'root' })
export class SnapshotBatchService {
    private _http = inject(HttpClient);
    private _base = `${environment.apiBaseUrl}/v1/snapshot-batches`;

    getRuns(page?: number, pageSize?: number): Observable<PaginatedResult<SnapshotRunSummary>> {
        const params: Record<string, string> = {};
        if (page !== undefined) params['page'] = page.toString();
        if (pageSize !== undefined) params['pageSize'] = pageSize.toString();
        return this._http.get<PaginatedResult<SnapshotRunSummary>>(this._base, { params });
    }

    getJobStatus(jobId: string): Observable<SnapshotBatchJobStatus> {
        return this._http.get<SnapshotBatchJobStatus>(`${this._base}/${jobId}`);
    }

    getSnapshotsByBatch(jobId: string, page?: number, pageSize?: number): Observable<PaginatedResult<SnapshotBatchItem>> {
        const params: Record<string, string> = {};
        if (page !== undefined) params['page'] = page.toString();
        if (pageSize !== undefined) params['pageSize'] = pageSize.toString();
        return this._http.get<PaginatedResult<SnapshotBatchItem>>(`${this._base}/${jobId}/snapshots`, { params });
    }

    createBatch(note?: string): Observable<CreateSnapshotBatchResponse> {
        return this._http.post<CreateSnapshotBatchResponse>(this._base, { note });
    }
}
